import axios from 'axios';
import * as endpoints from './const';

class ServicenowApi {
  static submitInterest() {
    return axios
      .post(`${endpoints.SERVICENOW_SUBMIT_INTEREST}`)
      .then(response => response.data)
      .then(data => data);
  }

  static GetServicenowSSO() {
    return axios
      .get(`${endpoints.SERVICENOW_SSO}`)
      .then(response => response.data)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }
}

export default ServicenowApi;



// WEBPACK FOOTER //
// ./src/api/ServicenowApi.js